import React from 'react';
import Radio from './radio';

export default class RadioButton extends React.Component {
  static defaultProps = {
    prefixCls: 'ant-radio-button',
  }
  render() {
    return (
      <Radio {...this.props} />
    );
  }
}



// WEBPACK FOOTER //
// ./_antd1.11.2/radio/radioButton.jsx